<template>
    <layout-basic>
        <v-container>
            <section class="banner-text">
                <v-row class="text-center">
                    <v-col md="12">
                        <h1 class="font-sora thanks-title">Thank you!</h1>
                        <p class="thanks-subtext fs-22">Thanks for contacting us. One of our team will get in touch with you shortly.</p>
                    </v-col>
                </v-row>
            </section>
        </v-container>
    </layout-basic>
</template>

<script>
    import LayoutBasic from "@/layouts/Dashboard";
    export default {
        name: "Thankyou",
        components: {
            LayoutBasic,
        }
    }
</script>